import { Field } from 'formik';
import { memo, useMemo } from 'react';

import { BaseTextFieldProps, TextField } from '@mui/material';

import { InterviewLanguage } from '@synergetx/puppet-interview-types';

interface Props {
    position: number;
    language: InterviewLanguage;
}

const QuestionPromptField = ({ position, language }: Props) => {
    const fieldInputProps: BaseTextFieldProps = useMemo(
        () => ({
            style: { minWidth: '15rem' },
            onFocus: (e) => {
                e.target.select();
            },
            onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
            },
        }),
        [],
    );
    return (
        <Field
            key={`question.prompt - ${position}`}
            as={TextField}
            fullWidth
            name={`questions[${position}].localeContent.[${language}].content`}
            label="Prompt"
            required
            variant="filled"
            style={{ marginBottom: '1rem' }}
            placeholder="Question prompt goes here..."
            slotProps={{ input: fieldInputProps, inputLabel: { shrink: true } }}
        />
    );
};

export default memo(QuestionPromptField);
